export const authPrimaryButtonClassName = 'h-auto min-h-11 w-full whitespace-normal py-2.5';
export const authLinkClassName = 'font-medium text-[#287d36] underline-offset-4 hover:text-[#1f6b2e] hover:underline';
export const authErrorClassName = 'rounded-lg border border-red-100 bg-red-50 px-4 py-3 text-sm leading-6 text-red-800';
export const authNoticeClassName = 'rounded-lg border border-green-100 bg-[#f2f8f2] px-4 py-3 text-sm leading-6 text-[#246b30]';
